import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../../../FormGroup';
import { I18nContext } from 'utils/I18n/context';

const Helper = ({ children }) => {
    const { t } = useContext(I18nContext);
    
    const renderTitle = () => {
        let staticNames = t?.paymentPage?.settingModal || {};

        return (
            <FormGroup>
                <h3>{staticNames.requisites}</h3>
            </FormGroup>
        );
    };

    return children({ renderTitle });
};

Helper.propTypes = {
    children: PropTypes.func.isRequired
};

export default Helper;
